import React, { Component } from 'react';
import { Wrapper } from "components";
import styled from "react-emotion";
import Img from 'gatsby-image';
import backgroundImage from '../shared/images/banner_partners.png';
import _ from 'lodash';

const PartnersContainer = styled.div`
    background: url(${backgroundImage}) no-repeat;
    background-position: center;
    background-size: cover;
    padding-top: 4rem;
    padding-bottom: 4rem;
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        padding-top: 0rem;
        padding-bottom: 2rem;
    }
`;

const StylePartners = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const PartnerHeader = styled.div`
    width: 50%;
    margin-top: 1rem;
    @media (max-width: ${props => props.theme.breakpoints.l}) {
        width: 50%;
    }
    @media (max-width: ${props => props.theme.breakpoints.m}) {
        width: 50%;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        width: 100%;
    }
`;

const PartnerTitle = styled.h1`
    font-size: 1.75rem;
    margin: 0;
    color: ${props => props.theme.colors.red};
`;

const PartnerSubtitle = styled.p`
    font-size: 0.85rem;
`;

const PartnerTiles = styled.div`
    width: 50%;
    display: flex;
    flex-wrap: wrap;
    padding-left: 2rem;
    @media (max-width: ${props => props.theme.breakpoints.l}) {
        width: 50%;
    }
    @media (max-width: ${props => props.theme.breakpoints.m}) {
        width: 50%;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        width: 100%;
        padding-left: 0;
    }
`;

const PartnerTileSquare = styled.div`
    background: white;
    position: relative;
    width: ${100/3}%;
    border-style: solid;
    border-width: 0.5px;
    border-color: ${props => props.theme.colors.greyLight};
`;

const PartnerTileRectangle = styled.div`
    background: white;
    position: relative;
    width: 100%;
    border-style: solid;
    border-width: 0.5px;
    border-color: ${props => props.theme.colors.greyLight};
`;

class Partners extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        const { partners } = this.props;
        // Limit to top 4
        const topPartners = partners.slice(0, 4);
        const partnerTiles = _.sortBy(topPartners, ['node.uid']).map(partner => {
            if (partner.node.data.name.text === 'App Haus') {
                return <PartnerTileRectangle key={partner.node.uid}>
                    <Img fluid={partner.node.data.company_logo.localFile.childImageSharp.fluid} />
                </PartnerTileRectangle>    
            } else {
                return <PartnerTileSquare key={partner.node.uid}>
                    <Img fluid={partner.node.data.company_logo.localFile.childImageSharp.fluid} />
                </PartnerTileSquare>
            }}
        );
        return (
            <PartnersContainer>
                <Wrapper>
                    <StylePartners>
                        <PartnerHeader>
                            <PartnerTitle>The right partners for your needs</PartnerTitle>
                            <PartnerSubtitle>Bourne Digital partners with leading brands to adopt user-led business simplification and enable digital solutions for the enterprise.</PartnerSubtitle>
                        </PartnerHeader>
                        <PartnerTiles>{partnerTiles}</PartnerTiles>
                    </StylePartners>
                </Wrapper>
            </PartnersContainer>
        );
    }
}

export default Partners;